module.exports = __webpack_public_path__ + "static/media/Modern_Background.aa11b6c0.png";